import { render, staticRenderFns } from "./DetalleDeclaracion.vue?vue&type=template&id=f211b778&"
import script from "./DetalleDeclaracion.vue?vue&type=script&lang=js&"
export * from "./DetalleDeclaracion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports